module.exports = __webpack_public_path__ + "static/media/calendar.4c3fdd11.svg";